import React, { useContext } from 'react'
import { Button, Card, Icon, Label, Image} from 'semantic-ui-react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { AuthContext } from '../context/auth';
import LikeButton from './LikeButton';
import DeleteButton from './DeleteButton';
import MyPopup from '../util/MyPopup';

function PostCard({
  post :{ body, createdAt, id, username, likeCount, commentCount, likes, comments }
}) {
const { user } = useContext(AuthContext);

  return (
    <div>
      <Card fluid>
        <Card.Content>
          <Image
            floated='right'
            size='mini'
            src='https://react.semantic-ui.com/images/avatar/large/molly.png'
          />
          <Card.Header>{username}</Card.Header>
          <Card.Meta as={Link} to={`/posts/${id}`}>{moment(createdAt).fromNow(true)}</Card.Meta>
          <Card.Description>
            <strong>{body}</strong>
          </Card.Description>
        </Card.Content>

        <Card.Content extra>
        
          {/* like button  */}
          <LikeButton user={user} post={{id, likes, likeCount}}/>
          
          {/* Comment button */}
          <MyPopup
            content="Content on post"
          >
            <Button labelPosition='right' as={Link} to={`/posts/${id}`}>
              <Button color='blue' basic> 
                <Icon name='comments'/>
              </Button>
              <Label basic color='blue' pointing='left'>
                {commentCount}    
              </Label>
            </Button>
          </MyPopup>          

          {/* delete post button */}
          {
            user && user.username === username && <DeleteButton postId={id}/>
          }
        </Card.Content>
      </Card>
    </div>
  )
}

export default PostCard; 